var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1754 0.649231H0V21.3508H20V10.4737H17.8948V19.2456H2.10525V2.75448H10.1754V0.649231Z",
    fill: "#18A0FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6313 2.75429H16.406L7.01735 12.1429V8.36828H4.91211V15.7366H12.2805V13.6314H8.50615L17.8946 4.24309V8.01741H19.9999V0.649048H12.6313V2.75429Z",
    fill: "#18A0FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon07);
export default __webpack_public_path__ + "static/media/company-icon-07.643416722b6bfb8a95576cc23fcab8ff.svg";
export { ForwardRef as ReactComponent };